import { jsxs as p, jsx as e } from "react/jsx-runtime";
import { withManagedProps as c } from "@made-people/managed-props";
import { z as o } from "zod";
import { withZod as d } from "@made-people/react-prop-guard";
import { logosAndTextTemplate1Blueprint as T } from "./index-blueprint.es.js";
import { componentWrapperSchema as s, ComponentWrapper as u } from "@made-people/blueprint-component-wrapper";
import { headingSchema as A, Heading as y } from "@made-people/blueprint-heading";
import { badgeSchema as L, Badge as S } from "@made-people/blueprint-badge";
import { Markdown as N } from "@made-people/blueprint-markdown";
import { partnerLogosSchema as i, PartnerLogos as j } from "@made-people/blueprint-partner-logos";
import "@made-people/blueprint";
const f = o.object({
  template: o.literal("template1"),
  layout: s.shape.layout.optional(),
  variants: o.custom().optional(),
  text: o.string().optional(),
  heading: A.optional(),
  link: o.object({
    label: o.string().optional(),
    href: o.string().optional()
  }).optional(),
  badge: L.optional(),
  logos: i.array().or(i).optional().transform((t) => Array.isArray(t) ? t[0] : t),
  children: o.custom().optional()
  // Used for arbitrary CTAs
}).merge(s), w = c(
  "LogosAndTextTemplate1",
  d(
    {
      schema: f,
      defaultProps: { template: "template1" }
    },
    ({
      variants: t,
      text: l,
      heading: a,
      link: k,
      layout: g,
      badge: n,
      children: h,
      logos: m,
      ...x
    }) => {
      const r = T.styles(t);
      return /* @__PURE__ */ p(
        u,
        {
          className: r.wrapper,
          ...x,
          layout: { ...g },
          children: [
            /* @__PURE__ */ p("div", { className: r.content, children: [
              (n == null ? void 0 : n.label) && /* @__PURE__ */ e(S, { ...n }),
              (a == null ? void 0 : a.heading) && /* @__PURE__ */ e(y, { ...a }),
              l && /* @__PURE__ */ e(N, { content: l, className: r.text }),
              h
            ] }),
            /* @__PURE__ */ e("div", { className: r.logosWrapper, children: m && /* @__PURE__ */ e(j, { ...m, className: r.logos }) })
          ]
        }
      );
    }
  )
), P = o.discriminatedUnion("template", [
  f
]), D = c(
  "LogosAndText",
  d(P, (t) => t.template === "template1" ? /* @__PURE__ */ e(w, { ...t }) : null)
);
export {
  D as LogosAndText,
  w as LogosAndTextTemplate1,
  P as logosAndTextPropsSchema,
  f as logosAndTextTemplate1Schema
};
//# sourceMappingURL=index.es.js.map
